"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TrueViewDetail = void 0;
require("reflect-metadata");
var tsyringe_1 = require("tsyringe");
var trueview_detail_component_1 = require("./trueview-detail.component");
// container with specific providers,life time 
exports.TrueViewDetail = tsyringe_1.container
    .resolve(trueview_detail_component_1.TrueViewDetailComponent);
